import * as React from 'react';
import { convertArrayToTabBar } from './utils/tabBarFn';

export interface Props {}

export const data1 = ['Example'].map(convertArrayToTabBar);

export const SnackBarDocumentation: React.FC<Props> = (props) => {
  return <div></div>;
};
